import axios from 'axios';
import api from './endpoints';

export default {
  login(args) {
    return axios.post(api.LOGIN, args)
      .then((data) => data.data);
  },

  userInfo() {
    return axios.get(api.USER).then((data) => data.data);
  },

  forgotPassword(args) {
    return axios.post(api.FORGOT_PASSWORD, args).then((data) => data.data);
  },

  resetPassword(args) {
    return axios.post(api.RESET_PASSWORD, args).then((data) => data.data);
  },

  registerUser(args) {
    return axios.post(api.REGISTER_USER, args).then((data) => data.data);
  },
  sendVerificationEmail(args) {
    return axios.post(api.VERIFY_EMAIL, args).then((data) => data.data);
  },
  verifyEmailToken(args) {
    return axios.put(api.VERIFY_EMAIL, args).then((data) => data.data);
  }
};
